<template>
  <div v-show="show" class="mt-3 small">

    <div class="mb-3">
      <div class="fw-semibold mb-1">Purpose</div>
      <ul class="mb-0">
        <li>Configure encoder stream setup for all channels assigned to the selected event.</li>
        <li>Display and maintain data from Encoder per channel.</li>
        <li>The goal is to have each channel connected with one encoder stream</li>
        <li><img src="@/assets/reload.svg" alt="" class="btn-icon" /> reload data, which fetches the data from the encoder site based on stream id with the lst time it has been updated (same as Events)</li>
      </ul>
    </div>

    <div class="mb-3">
      <div class="fw-semibold mb-1">Channels table</div>
      <ul class="mb-0">
        <li> Shows channel name, ordering, data extracted from the encoder data fields
          (encoder, stream name/id, Input URLs). <strong>Origin</strong> and <strong>Destination Channel</strong>
          are extracted from the output url of the stream. </li>
        <li> Edit leads you to the Channel Edit page.</li>
        <li> The <strong>X</strong> button at the end removes this channel from this event. This sets this channel to the “empty” event. “empty” event is an event that has league named "Empty event". Dont delete or make this event active.</li>
        <li><strong>Add Channel</strong> below the table gives you the option to add a channel from the “empty” event to this event by updating its <code>eventId</code> to the one you're editing.</li>
      </ul>
    </div>

    <div class="mb-3">
      <div class="fw-semibold mb-1">Validation and mismatch detection</div>
      <ul class="mb-0">
        <li>Each channel is validated if it can be started or not. It shows the same error message as the Events page.</li>
        <li>If configuration is invalid, a mismatch message is shown under the channel name in red.</li>
        <li>Before saving, you will see the difference in the output URL that will be set.</li>
      </ul>
    </div>

    <div class="mb-3">
      <div class="fw-semibold mb-1">Encoder Streams editor (per channel)</div>
      <ul class="mb-0">
        <li>
          Click <strong>Encoder Streams</strong> to open the encoder streams, below the tabe for the selected channel.
          With a yellow line around the channel in the table you can see which channels encoder data you are editing.
        </li>
        <li>Channels without data from encoders can be initialized by selecting an encoder and importing the data from one of the stream.</li>
        <li>If you want to connect the channel to a different stream, you can preview then save data from a different stream, or just remove the encoder data that channel has.</li>
        <li>Streams on encoders are never deleted, their input and output urls are being edited.</li>
      </ul>
    </div>

    <div class="mb-3">
      <div class="fw-semibold mb-1">Saving configuration</div>
      <ul class="mb-0">
        <li>For changes to be sent to Encoder site for the input streams urls, or their order, Save Stream button must be clicked. A red notification text will pop up once you make any changes.</li>
        <li>
          On save, the output URL is built to include data for this channel, and it goes like:
          <strong>rtmp://${origin}.procricket.cloud/${stream_app}/${channel_name}?key=654321&id=${eventId}</strong>
          and pushed to the encoder.
        </li>
        <li><strong>channel_name</strong> is the Name of the channel you currently set up</li>
        <li><strong>stream_app</strong> is the channel's own stream app (the same one B-API uses), not taken from the application or the channel name</li>
        <li>The data from the encoder is then refreshed so the UI reflects the current provider configuration.</li>
      </ul>
    </div>

    <div class="mb-3">
      <div class="fw-semibold mb-1">Input sources (hardcoded or IPTV/M3U)</div>
      <ul class="mb-0">
        <li>Input URLs can be inserted manually or loaded from IPTV sources.</li>
        <li>
          IPTV streams are loaded via the Broadcast-API which parses a m3u file and the outputs stream names are displayed
          in the dropdown, which can be searched to access the specific stream you want. When you select the stream you want,
          press ADD to add it as a input url.
        </li>
        <li>In case the selected IPTV doesnt give out options, contact support for the fix.</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventBroadcastHelp",
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ["close"]
};
</script>
